import { jumpType } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import { getUrlObject } from '@/common/utils/browser';
import queryString from 'query-string';

type biddingJumpTo = (mainAppBaseUrl?: queryItem[] | queryItem, queryStr?: string, jumpType?: jumpType) => void;

type generateJumpTo = (
  mainAppBaseUrl?: queryItem[] | queryItem,
  mainAppQuery?: queryItem[] | queryItem
) => (query: queryItem[] | queryItem, type: jumpType, location: string) => void;

type queryItem = string | Record<string, string>;

/**
 *
 * queryItem: 'a', 'a=1', {a: 1}
 * query1, query2: queryItem[]
 *
 * query1: ['/a?a=1', {b: 2}] -> /a?a=1&b=2
 * query1: ['a=1'] query2: ['a=2'] -> 'a=2'
 *
 */
function mergeQuery(query1: queryItem | queryItem[], query2?: queryItem | queryItem[]): string {
  const searchObj = getUrlObject();
  let query: string[] = [];

  if (query1) {
    if (Array.isArray(query1)) query1.forEach(parseItem);
    else parseItem(query1);
  }

  if (query2) {
    if (Array.isArray(query2)) query2.forEach(parseItem);
    else parseItem(query2);
  }

  const res = query
    .filter((item) => !!item)
    .map((item) => {
      if (item.startsWith('?') || item.startsWith('&')) return item.slice(1);
      return item;
    })
    .reduce((total, cur) => {
      if (cur.startsWith('/')) {
        if (cur.includes('?')) return cur + '&' + total;
        return cur + '?' + total;
      }
      if (cur.includes('=')) {
        return total ? total + '&' + cur : cur;
      }
      const value = searchObj[cur];
      if (value == null) return total;
      else return total + '&' + cur + '=' + encodeURIComponent(String(searchObj[cur]));
    }, '');

  // 防止有重复 a=1&a=1 需要被格式化为 a=1
  return queryString.stringifyUrl(queryString.parseUrl(res));

  // a=1&b=1
  // /path?a=1&b=2
  // a
  // {a: 1, b: 2}
  function parseItem(item: queryItem) {
    if (typeof item === 'string') query.push(item);
    if (typeof item === 'object')
      Object.keys(item).forEach((key: string) => {
        item[key] != null && query.push(`${key}=${item[key]}`);
      });
  }
}

export type { generateJumpTo, queryItem, biddingJumpTo };

export { mergeQuery };
